Filter = App.loadClass 'core::viewmodels/filters/Filter'

exports.Sidebar = (filters_input = []) ->
    self = this

    ###
    Imports a new filter group and it's child filters
    ###
    @importGroup = (group) ->
        filter_list = []
        for f in group.filters
            filter_list.push new Filter self, f
        group.filters = ko.observableArray filter_list
        if group.display_name?
            group.display_name = ko.observable group.display_name
        else
            group.display_name = ko.observable group.name
        group.visible = ko.observable true

        self.filter_groups.push group

    ###
    Removes a filter group from the sidebar
    ###
    @removeGroup = (group) ->
        if not self.filter_groups?
            return false

        for k in self.filter_groups()
            if k.name is group
                self.filter_groups.remove k
                return true
        return false

    ###
    Hide a filter group in the sidebar
    ###
    @hideGroup = (group) ->
        if not self.filter_groups?
            return false

        for k in self.filter_groups()
            if k.name is group
                k.visible false
                #disable all filters within?
                return true
        return false

    ###
    Show a filter group in the sidebar
    ###
    @showGroup = (group) ->
        if not self.filter_groups?
            return false

        for k in self.filter_groups()
            if k.name is group
                k.visible true
                return true
        return false

    ###
    Disable a filter group in the sidebar
        NB. Disabling a filter also hides it
    ###
    @disableGroup = (group) ->
        @hideGroup(group)

        for grp in self.filter_groups()
            if grp.name is group
                for filter in grp.filters()
                    filter.disableFilter()

    ###
    Enable a filter group in the sidebar
        NB. Enabling a filter also shows it
    ###
    @enableGroup = (group) ->
        @showGroup(group)

        for grp in self.filter_groups()
            if grp.name is group
                for filter in grp.filters()
                    filter.enableFilter()

    ###
    Assign a new display name to filter group
    ###
    @assignGroupName = (group, name) ->
        if not self.filter_groups?
            return false

        for k in self.filter_groups()
            if k.name is group
                k.display_name name
                return true
        return false

    ###
    Refresh filters from the backend
    ###
    @fetchFilters = (url = null, cb = null, turnOffFetching = true) ->
        if not url?
            url = self.recent_fetch_url

        self.recent_fetch_url = url

        json = ko.toJSON self.jsonize(true)

        # nice for debugging fetch time
        #console.time('fetch timer')
        self.fetching(true)
        $.post url, { query: json }, (response) ->
            # Make sure we didn't switch report tab while the filters are loading
            if url isnt self.recent_fetch_url
                return

            self.sidebarExtraData = response?.data?.sidebar_extra_data

            for filter, values of response.data
                f = self.findInGroup filter
                if f isnt false
                    f.populateValues values

                # first check auto_clear_unavailable because it can be run in addition to other flags
                if f.auto_clear_unavailable
                    for selected in f.selected_values()
                        if not values.filter((item) => item.key is selected.key).length
                            # deselect the value
                            f.unselectFilter(selected)

                if f.auto_select_only_value and values.length is 1
                    f.applyFilter(values[0], true)
                else if f.auto_select_first and f.selected_values().length is 0
                    f.applyFilter(values[0], true)
                else if f.auto_select_by_default_flag and f.selected_values().length is 0 and values.length
                    # auto select the value that has a "default" property that is set to true
                    f.applyFilter(values.find((item) => item.default), true)
                # This handles a specific case where a filter value that used to be selected on a single_dropdown is no longer available but there are other options available, one of which is a default value, without overriding existing selections
                else if f.auto_select_by_default_flag and f.selected_values().length is 1 and f.selected_values()[0].isSelectedInParent() is false and values.length
                    # auto select the value that has a "default" property that is set to true
                    f.applyFilter(values.find((item) => item.default), true)

            if cb?
                cb()

            if turnOffFetching
                self.fetching(false)
            #console.timeEnd('fetch timer')


    ###
    Shortcut for finding a filter without knowing which group
    it belongs to
    ###
    @findInGroup = (filter, cut = false) ->
        if not self.filter_groups?
            return false

        for g in self.filter_groups()
            for f, index in g.filters()
                if f.name is filter
                    if cut
                        return g.filters.splice(index, 1)[0]
                    else
                        return f
        return false

    ###
    Converts our structure into a nicely passable format for
    both fetching new filters and for running report queries
    Inactive querys need to be included sent when computing filters
    but not when computing report or excel exports
    ###
    @jsonize = (includeInactive = false) ->
        arr = {}
        for fg in self.filter_groups()
            for f in fg.filters()
                if f.enabled()
                    vals = []
                    for sv in f.selected_values()
                        if includeInactive or sv.isSelectedInParent()
                            key = sv.key
                            if typeof key is 'object'
                                key = JSON.stringify key
                            vals.push
                                key: encodeURIComponent(key)
                                value: encodeURIComponent(sv.value)

                    arr[f.name] = vals

        return { filters: arr }


    @clearAllFilters = () ->
        for fg in self.filter_groups()
            for f in fg.filters()
                if f.deletable
                    f.selected_values.removeAll()

        self.fetchFilters()


    ###
    Returns original filter structure (aka what is seen in the report fluent filter)
    filter: name of filter to move
    to:     name of group to move filter to
    after:  name of filter before which the moved filter shall be put
            if after is null then the filter will be put at the top of the group
    returns:  true if filter was successfully moved
    ###
    @moveFilter = (filter, to, before = null) ->
        # cut the filter out
        to_move = self.findInGroup(filter, true)

        # if the filter was not found return
        if not to_move
            return false

        # paste the filter back in
        for g in self.filter_groups()
            if g.name is to
                if before?
                    for f, index in g.filters()
                        if f.name is before
                            g.filters.splice(index, 0, to_move)
                            return true

                g.filters.unshift to_move

        return true


    ###
    Returns original filter structure (aka what is seen in the report fluent filter)
    ignoredFltrs: array of filter names to exclude
    ignoredGrps: array of group names to exclude
    ###
    @exportStructure = (ignoredFltrs = [], ignoredGrps = []) ->
        structure = []

        # loop over each group
        for g in self.filter_groups()
            if ignoredGrps.indexOf(g.name) is -1
                group =
                    name: g.name,
                    display_name: g.display_name(),
                    filters: []

                # loop over each filter in the group
                for f in g.filters()
                    if ignoredFltrs.indexOf(f.name) is -1
                        # loop over each attribute in the filter
                        filter = []
                        for attr, value of f
                            if ko.isObservable(value)
                                filter[attr] = value()
                            else
                                filter[attr] = value

                        group.filters.push filter

                structure.push group

        return structure


    # Continue with init
    self.recent_fetch_url = null
    self.filter_groups = ko.observableArray()

    self.fetching = ko.observable(false)

    # list of groups, used for displaying filters
    for fs in filters_input
        self.importGroup fs

    return this
